<template>
  <section class="finalize-step">
    <div v-if="autoSave && isSaving" role="status" class="finalize-card">
      <v-progress-circular indeterminate />
      <mrx-translation token="app.loading.title" />
    </div>
    <div v-else class="finalize-card bg-white rounded-xl border border-slate-200/80 shadow-sm">
      <div v-if="saveFailed" id="save-results-error" role="alert" class="finalize-card__error">
        <mrx-translation token="app.upload.save.error" />
      </div>
      <mrx-translation
        v-else
        class="finalize-card__instructions"
        token="app.upload.save.instructions"
      ></mrx-translation>

      <button
        id="save-results"
        type="button"
        data-analytics-skip
        class="finalize-card__save"
        :disabled="isSaving"
        :aria-describedby="saveFailed ? 'save-results-error' : undefined"
        @click="$emit('save')"
      >
        <mrx-translation token="app.upload.save.button"></mrx-translation>
      </button>

      <div v-if="!autoSave" class="finalize-card__divider"></div>

      <mrx-translation
        v-if="!autoSave"
        class="finalize-card__instructions finalize-card__instructions--secondary"
        token="app.upload.discard.instructions"
      ></mrx-translation>

      <button
        v-if="!autoSave"
        id="discard-results"
        type="button"
        class="finalize-card__discard"
        :disabled="isSaving"
        @click="$emit('discard')"
      >
        <mrx-translation token="app.upload.discard.button"></mrx-translation>
      </button>
    </div>

    <v-dialog
      :value="showDiscardDialog"
      max-width="440px"
      overlay-color="#0f1e26"
      overlay-opacity="0.6"
      persistent
    >
      <v-card class="referral-dialog">
        <v-card-title class="referral-dialog__title">
          {{ $t('app.dialog.discard_title') }}
        </v-card-title>
        <v-card-text class="referral-dialog__description">
          {{ $t('app.dialog.discard_warning') }}
        </v-card-text>
        <v-card-actions class="referral-dialog__actions">
          <v-btn
            id="cancel-discard"
            data-analytics-skip
            class="referral-dialog__btn-no"
            outlined
            @click="$emit('discard-decision', false)"
          >
            {{ $t('app.dialog.button.no') }}
          </v-btn>
          <v-btn
            id="confirm-discard"
            data-analytics-skip
            class="referral-dialog__btn-discard"
            @click="$emit('discard-decision', true)"
          >
            {{ $t('app.dialog.button.yes_discard') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MrxTranslation from '@/components/thinkmd/mrx/translation.vue';

export default defineComponent({
  name: 'SaveOrDiscardStep',

  components: {
    MrxTranslation,
  },

  props: {
    autoSave: {
      type: Boolean,
      default: false,
    },
    showDiscardDialog: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    saveFailed: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['save', 'discard', 'discard-decision'],
});
</script>
